<template lang="html">
  <div
    v-if="!loading"
    class="loginForm w-full bg-herored h-full"
  >
    <div class="px-8 md:px-16 pb-8 pt-12 relative">

      <h2 v-if="state == 'email'" class="block text-white w-full text-center mb-8 text-2xl">Enter your email address</h2>
      <h2 v-if="state == 'password'" class="block text-white w-full text-center mb-8 text-2xl">Enter your password</h2>
      <h2 v-if="state == 'new'" class="block text-white w-full text-center mb-8 text-2xl">Create an account</h2>

      <!-- Warning Message -->
      <div role="alert" v-if="error">
        <div class="rounded bg-red-100 px-4 py-3 mb-3 text-red-700">
          {{ error }}
        </div>
      </div>
      <!-- Privacy Policy Main Body -->
      <div v-if="state == 'terms'" class="w-full">
        <div class="flex justify-center"> 
          <b class="text-white pb-4"> Data protection policy </b> 
        </div>
        <div class="flex justify-center pb-10">
          <p class="text-white"> In using this website, your log on data will be shared with both the website owners (H&H) and Arco. This data will be used to shape future Blackfriargate and other communications. This data will not be shared with any other third parties. </p>
        </div>
      </div> 
      <!-- Login Method-->
      <div
        v-if="state == 'email'"
        class="m-1 mt-0 text-white mb-4"
        :class="fieldanimation"
      >
        <label class="text-base text-center w-full block" for="email">
          <input
            @keyup.enter="next"
            :class="wronganimation"
            id="email"
            type="email"
            class="shadow-lg rounded-lg mb-2 border-white border-2 appearance-none bg-white w-full py-3 px-3 leading-tight focus:outline-none focus:shadow-outline text-gray-700"
            name="email"
            value
            required
            autofocus
            v-model="form.email"
            placeholder="Email"
          />
        </label>
      </div>
      <div
        v-if="state == 'password' || state == 'new'"
        class="m-1 mt-0 text-white mb-4 animated"
        :class="fieldanimation"
      >

      <div v-if="state == 'new'">
        
        <div class="relative">
          <select
            v-model="roleSelect"
            class="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            id="role"
          >
            <option
              v-for="(option, i) in roles"
              v-bind:key="i"
              v-bind:value="option"
              >{{ option.name }}</option
            >
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
              />
            </svg>
          </div>
        </div>
      </div>

        <div class="mt-4 relative">

        <label class="text-base text-center w-full block" for="password">
          <input
            @keyup.enter="login"
            id="password"
            placeholder="Password"
            :type="revealpw"
            class="shadow rounded mb-2 text-gray-500 appearance-none bg-white border w-full py-3 px-3 leading-tight focus:outline-none focus:shadow-outline"
            name="password"
            required
            v-model="form.password"
          />
        </label>
        <!-- Passord Eyball thing -->
        <a
          v-if="revealpw == 'password'"
          @click="revealpw = 'text'"
          class="absolute text-gray-500 right-0 bottom-0 mb-2 text-3xl mr-3"
        >
          <i class="fas fa-eye-slash"></i>
        </a>
        <a
          v-if="revealpw == 'text'"
          @click="revealpw = 'password'"
          class="absolute text-gray-500 right-0 bottom-0 mb-2 text-3xl mr-3"
        >
          <i class="fas fa-eye"></i>
        </a>
      </div>
      <div
        v-if="state == 'new'"
        class="text-white mb-4 animated relative"
        :class="fieldanimation"
      >
        <label class="text-base text-center w-full block" for="confirmpassword">
          <input
            @keyup.enter="createUser"
            id="confirmPassword"
            placeholder="Confirm Password"
            :type="revealpw"
            class="shadow rounded mb-2 mt-2 text-gray-500 appearance-none bg-white border w-full py-3 px-3 leading-tight focus:outline-none focus:shadow-outline"
            name="confirmPassword"
            required
            v-model="form.confirmPassword"
          />
        </label>
        <!-- Passord Eyeball thing -->
        <a
          v-if="revealpw == 'password'"
          @click="revealpw = 'text'"
          class="absolute text-gray-500 right-0 bottom-0 mb-2 text-3xl mr-3"
        >
          <i class="fas fa-eye-slash"></i>
        </a>
        <a
          v-if="revealpw == 'text'"
          @click="revealpw = 'password'"
          class="absolute text-gray-500 right-0 bottom-0 mb-2 text-3xl mr-3"
        >
          <i class="fas fa-eye"></i>
        </a>
      </div>

      </div>

      <!-- Upload and Confirm -->

      <!-- Privacy Policy -->
      <div v-if="state == 'terms'" class="mt-1 mx-auto flex justify-center">
        <button
          @click.prevent="terms"
          class="border-2 bg-herored border-white text-white font-bold py-2 text-left pl-4 w-24 block relative rounded shadow mr-4"
        >
          Accept
        </button>
        <button
          @click.prevent="exit"
          class="border-2 bg-herored border-white text-white font-bold py-2 text-left pl-4 w-24 block relative rounded shadow"
        >
          Decline
        </button>
      </div> 
      <!-- -->

      <div v-if="state == 'email'" class="mt-1 mx-auto table">
        <button
          @click.prevent="next"
          class="border-2 bg-herored border-white text-white font-bold py-2 text-left pl-4 w-24 block relative rounded shadow"
        >
          Next
          <i class="fas absolute right-0 top-0 mr-3 mt-3 fa-chevron-right"></i>
        </button>
      </div>
      <div v-if="state == 'password'" class="mt-1 mx-auto table">
        <button
          @click.prevent="login"
          type="submit"
          class="border-2 border-white text-white font-bold py-2 text-left pl-4 w-24 block relative rounded shadow"
        >
          Log in
          <i class="fas absolute right-0 top-0 mr-3 mt-3 fa-chevron-right"></i>
        </button>
      </div>

      <div v-if="state == 'new'" class="mt-1 mx-auto table">
        <button
          @click="createUser"
          type="submit"
          class="border-2 border-white text-white font-bold py-2 pr-8 text-left pl-4 w-auto block relative rounded shadow"
        >
          Sign Up
          <i class="fas absolute right-0 top-0 mr-3 mt-3 fa-chevron-right"></i>
        </button>
      </div>
    </div>
    <!--<Waves />-->
  </div>
</template>

<script>
import firebase from "firebase/app";
// import PasswordReset from '@/components/PasswordReset.vue';
//import Waves from "@/components/background/Waves.vue";
export default {
  components: {
    //Waves
  },
  data() {
    return {
      allow:['arco.co.uk', 'arcoservices.co.uk', 'handhcomms.co.uk'],
      loading: true,
      ok: null,
      roleSelect: { name: "Select Role" },
      roles: [
        { name: "Select Role" },
        { name: "CEC" },
        { name: "Commercial" },
        { name: "Digital & IT" },
        { name: "Directors" },
        { name: "Finance (inc Estates & Audit)" },
        { name: "HR" },
        { name: "Logistics (GMM)" },
        { name: "Marketing" },
        { name: "Safety Services" },
      ],
      reset: false,
      revealpw: "password",
      state: "terms",
      wronganimation: "",
      fieldanimation: "fadeInRight fast",
      height: 200,
      form: {
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        passcode: ""
      },
      error: null,
      movedown: false
    };
  },
  created() {
    //this.allowed()
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$router.replace({ name: "MainMenu" });
      } else {
        this.loading = false;
      }
    });
  },

  methods: {
    terms() {
      var vm = this
      vm.state = 'email'
    },
    exit() {
      var vm = this
      vm.$emit('closeModal', true);
    },  
    allowed() {
      // Get Email entered
      var email = this.form.email
      var emailcheck = email.split('@')
      console.log(emailcheck)
      var allow = this.allow;
      var n = allow.includes(emailcheck[1]);
      //console.log(n)
      var result = n
      return result;
    },
    next() {
      var vm = this;
      if(!vm.allowed()) {
        this.wronganimation = " animated shake ";
        setTimeout(function() {
          vm.$emit('closeModal', true);
        }, 3000);
        
        return;
      }
      if (!this.form.email) {
        this.error = "Please enter an email address";
        setTimeout(function() {
          vm.error = null;
        }, 3000);
        return;
      }
      // Check email exists

      // Email is OK
      firebase
        .auth()
        .fetchSignInMethodsForEmail(this.form.email)
        .then(data => {
          vm.state = data[0];
          if (!data.length) {
            vm.state = "new";
          }
          console.log(data[0]);
        })
        .catch(err => {
          vm.error = err.message;
          setTimeout(function() {
            vm.error = null;
          }, 3000);
        });
    },
    createUser() {
      if (this.form.password === this.form.confirmPassword) {
        var vm = this;
        firebase
          .auth()
          .createUserWithEmailAndPassword(vm.form.email, vm.form.password)
          .then(data => {
            data.user
              .updateProfile({
                displayName: this.form.name
              })
              .then(() => {
                //Build User table
                var firestore = firebase.firestore();
                const uid = firebase.auth().currentUser.uid;
                var userRef = firestore.collection("users").doc(String(uid));
                var analyticsRef = firestore.collection("analytics").doc('records');

                analyticsRef.update({
                  users: firebase.firestore.FieldValue.arrayUnion({
                    email: vm.form.email,
                    role: vm.roleSelect,
                    uid: uid,
                  })
                })

                userRef.set(
                  {
                    isAdmin: false,
                    hero: null,
                    email: vm.form.email,
                    role: vm.roleSelect,
                    uid: uid,
                    answerCats:[],
                    answerData:[]
                  },
                  { merge: true }

                );
              });
              vm.$emit('closeModal', true);
          })
          .catch(err => {
            vm.error = err.message;
            setTimeout(function() {
              vm.error = null;
            }, 3000);
          });
      } else {
        vm.error =
          "Make sure your passwords match and your email address is valid";
        setTimeout(function() {
          vm.error = null;
        }, 3000);
      }
    },
    login() {
      var vm = this;
      if (!vm.form.password) {
        vm.error = "Please enter your password";
        setTimeout(function() {
          vm.error = null;
        }, 3000);
        return;
      }
      firebase
        .auth()
        .signInWithEmailAndPassword(vm.form.email, vm.form.password)
        .then(data => {
          console.log(data);
          vm.$emit('closeModal', true);
        })
        .catch(function(error) {
          // Handle Errors here.
          //this.error = error.code;
          vm.error = error.message;
          setTimeout(function() {
            vm.error = null;
          }, 3000);
        });
    }
  }
};
</script>
